import { SUPPORTED_CURRENCIES, DEFAULT_CURRENCY } from '../constants/appConstants';

export function getCurrencySymbol(code = DEFAULT_CURRENCY) {
  const found = SUPPORTED_CURRENCIES.find((c) => c.code === code);
  return found?.symbol ?? code ?? '$';
}

export function formatCurrency(amount, currencyCode = DEFAULT_CURRENCY) {
  const symbol = getCurrencySymbol(currencyCode);
  const value = Number(amount || 0);
  return `${symbol}${value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

/** PDF formatting — uses the same symbols as on-screen (₪, $, €, etc.). */
export function formatCurrencyForPdf(amount, currencyCode = DEFAULT_CURRENCY) {
  const symbol = getCurrencySymbol(currencyCode);
  const value = Number(amount || 0).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return `${symbol}${value}`;
}

export function formatCurrencyWithCode(amount, currencyCode = DEFAULT_CURRENCY) {
  const value = Number(amount || 0);
  return `${currencyCode} ${value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}
